 export const routes = (prefix=`reports`, pre=`patients`) => [
    {
        name: `${prefix}.${pre}.progressnoteslist.index`,
        path: `/${prefix}/${pre}/progressnoteslist`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.progressnotes-report.index`,
                PageDescription: "Patient Reports: Progress Notes report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.progressnotes-report.index`,
        path: `/${prefix}/${pre}/progressnotes-report/print`,
        component: () => import('./print/Progressnotes.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.progressnotes-report.index`,
                PageDescription: "Patient Reports: Progress Notes report",
            },
            print: true,
        },
    },
     
];